var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-container",class:_vm.classObj,on:{"click":_vm.clickHandler}},[_c('p',[_vm._v(_vm._s(_vm.label))]),(_vm.isDraft)?_c('BaseIcon',{attrs:{"name":"clear","color":"white","fill":true},on:{"clicked":_vm.clearHandler}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }